/** @format */

import angular from 'angular';
import angularTranslate from 'angular-translate';
import { I18nModule } from 'crowdcomms-js/lib/i18n';

import { WidgetI18nConfig } from './widget-i18n.config.js';

export const WidgetI18nModule = angular
    .module('galabid-presenter.components.widget.i18n', [angularTranslate, I18nModule])
    .config(WidgetI18nConfig).name;
